// extracted by mini-css-extract-plugin
export default {"panel":"dnAi","container":"vmHv","status":"gEsM","messages-stored":"aTZN","messagesStored":"aTZN"};